import React, {useState, useEffect} from 'react'
import { ShareContainer, RegistContainer, FormCotainer, RegistModalContent, CTitle} from './style'
import {  InputItem , Toast, Modal} from 'antd-mobile';
import h5Share from '@/utils/h5Share'
import { rsaString } from '@/utils'
import {verifyPhone, sendMessage, register, getInvitationUserInfo } from '@/api/user-new'

// import prizeHeader from '@/img/user-new/prize-header.png'
// import closeModal from '@/img/user-new/close-modal.png'
// import openApp from '@/img/user-new/open-app.png'


const regPhone = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/
const SharePullRegist = ({props}) => {
  const [userInfo, setUsename] = useState({})
  const [value, setvalue] = useState('')
  const [code, setcode] = useState('')
  const [inviteCode, setinviteCode] = useState('')
  const [visible, setvisible] = useState(false)
  const [hasphone, setHasphone] = useState(false)
  const [type, setType] = useState('1')
  let [count, setCount] = useState(60)
  const activityId = 20;
  
  const getCode = () => {
    
    const val = value.replace(/\s*/g,"")
    if(!regPhone.test(val)){
      Toast.info('请输入正确手机号');
    } else {
      verifyPhone({C_PHONE: rsaString(val)}).then(res=> {
        if(res.resultCode === '00'){
          setType('1')
          setvisible(false)
          sendMessage({PHONE:rsaString(val), type: '0'}).then(res=>{
            if(res.resultCode === '00'){
              setHasphone(true)
              let timer = null
              clearInterval(timer)
              timer = setInterval(()=>{
                if(count === 0) {
                  clearInterval(timer)
                  setCount(60)
                  setHasphone(false)
                } else {
                  setCount(count--)
                }
              }, 1000)
            }
          })
        } else if(res.resultCode === '01') {
          setType('2')
          setvisible(true)
        } else if(res.resultCode === '01'){
          Toast.info('请输入正确手机号')
        }
      })
     
    }

  }
  const regist = () => {
    const val = value.replace(/\s*/g,"")
    if(regPhone.test(val)){
      const params ={
        phone: val, 
        smsCode: code,
        activityId: activityId, // 会员邀请活动 id 10，前端写死
        inviteCode: inviteCode
      }
      register(params).then(res=>{
        if(res.resultCode === '00'){
          setvisible(true)
          setType('1')
        } else {
          Toast.info(res.resultMsg);
        }
      })
    } else {
      Toast.info('请输入正确手机号')
    }
  }
  const openlink = () => {
    setvisible(false)
    window.location.href="https://filetest.wogoo.com/app/download/index.html"
  }

  const changeValue = val => {
    setcode(val)
  }
  const onChangePhone = val =>{
    setvalue(val)
  }
  const initPage = () => {
    let data = {}
    setinviteCode(props.match.params.code)
    
    getInvitationUserInfo({invitedCode: props.match.params.code}).then(res=>{

      if(res){
        setUsename(res)
         data = { 
          // title:  `@${res}喊您一起来用市值风云APP了`, 
          title: `${res.nickname}免费送您VIP使用权，快来领取吧`,
          desc: '付费研报、吾股异动，重磅权益限时免费体验', 
          link: window.location.href,
          imgUrl:  'https://file.wogoo.com/app/logo/logo6.png',
          wxShare:{
            shareData:{
              imgUrl: 'https://file.wogoo.com/app/logo/logo6.png'
            }
          }
        }
      h5Share.main(data)
      } else {
        setUsename('')
        data = {
          title: `${res.nickname}免费送您VIP使用权，快来领取吧`,
          desc: '付费研报、吾股异动，重磅权益限时免费体验',
          link: window.location.href,
          imgUrl:  'https://file.wogoo.com/app/logo/logo6.png',
          wxShare:{
            shareData:{
              imgUrl: 'https://file.wogoo.com/app/logo/logo6.png'
            }
          }
        }
        h5Share.main(data)
      }
      
   }).catch(err => {
     console.log(err);
   })
  }

  useEffect(() => {
    initPage()
    document.title = '风云VIP免费领'
    document.body.style = "background-color:#F23F56!important;"
  }, [])
 
  return (
    <ShareContainer>    
      <div className='user_box'>
            
      <div>
        <img className='avatar' src={userInfo.avatar} alt="" />
      </div>
      <div className='nickname'>{userInfo.nickname}</div>

      <div>
        <div className='tip'>邀请您领风云VIP</div>
        </div>
      </div>   
      {/* <img className='header' src={require('@/img/members0604/regist1.png')} alt=""></img> */}
      <img className="header" src={require('@/img/active20/s_head.png')} alt="市值风云" />
  
      <RegistContainer >
        <div className={'container'}>
   
          <FormCotainer>
            <div className={'form-item'} > 
              <InputItem type="phone" defaultValue={value}   editable  clear onChange={(val)=>onChangePhone(val)}>+86</InputItem>
            </div> 
             <div className={'form-item'}>
              <InputItem type="number" className={'text'} defaultValue={code} editable  clear maxLength={4} placeholder={'请输入验证码'} onChange={(val)=>changeValue(val)}/>
              {!hasphone? <div className={'button active'} onClick={()=> getCode()}>获取验证码</div>: 
              <div className={'button'}>{count} 后重新获取 </div>}
            </div>
            <div className={'regist'} onClick={()=>regist()}>
                <img className='header' src={require('@/img/active20/sbtn.png')} alt=""></img>
            </div> 
            <div  className={'message'} >领取后登录APP即可体验7天风云VIP权益</div>
            {/* <div className='tips'>登录APP即可体验3天会员权益</div> */}
          </FormCotainer>
          {/* :<Center><Empty text={'抱歉，邀请信息不正确，无法访问'} imageSrc={ require(`@/img/user-new//pic_zwdw2x.png`)}/></Center>} */}
        </div>
      </RegistContainer>
      
      <img className='footer' src={require('@/img/active20/sbg2.png')} alt=""></img>
      <footer >活动一切解释权归市值风云所有 <br></br>投资有风险 入市需谨慎</footer>
      <Modal
          visible={visible}
          transparent
          className={'regist-modal'}
          maskClosable={true}
          onClose={()=> setvisible(false)}
          title=""
        >
          <RegistModalContent>
            <CTitle type={type}>
               <div className='back'></div>
               <div className='title'>{type==='1'? '恭喜': '提示'}</div>
               {/* {type==='1' ? <img className="prize-header" src={prizeHeader} alt="" /> : ''} */}
            </CTitle>
           <div className={'regist-modal-content-text'}>{type==='1'? '恭喜，您已经成功领取到风云VIP权益， 快前往市值风云APP使用': <div>该手机号已注册过市值风云，打开<br/>APP前往积分中心兑风云VIP</div>}</div>
           <div className={'regist-modal-content-group'}>
            {type ==='2' &&<div className='regist-modal-button'>
              <div onClick={()=>setvisible(false)} className='modal-button'>关闭</div>
              <div onClick={()=>openlink()} className='modal-button'>打开APP</div>
             </div>}
            {type ==='1' &&<div className={'regist-modal-content-button'} onClick={()=>openlink()}>打开APP</div>}
           </div>
          </RegistModalContent>
        </Modal>
    </ShareContainer>
  )
}

export default SharePullRegist


// WEBPACK FOOTER //
// ./src/views/integral_0803_20/share-pull-regist/index.js